export default "__VITE_ASSET__LcnxmmZH__"